<div class="location-finder-header-outer">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 class="headline">{{'common.storeFinder_find_a_store'|cxTranslate}}</h1>

        <div class="store__finder--search">
          <div class="row">
            <div class="col-sm-8 input-row">


              <input id="storelocator-query" name="q" (keyup)="validate($event)" (keydown.enter)="searchStore()"
                [(ngModel)]="storeSearchText" class="form-control js-store-finder-search-input form-control"
                placeholder="{{'common.pickup_search_message'|cxTranslate}}" type="text" value="">
            </div>

            <button class="btn btn-primary search-btn" [disabled]="pinLengthCheck || onlyDigitNumber"
              id="storeSearchSubmit" (click)="searchStore()">
              <span><i class="fa fa-search" aria-hidden="true"></i></span>
            </button>

          </div>
        </div>

        <p class="input-error alternateCity" *ngIf="">{{'common.storelocator_notFound_validation'|cxTranslate}}
        </p>

      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="showMapData">
  <div class="store__finder--pagination" *ngIf="storeDetails$ | async as storeDetails">
    <div class="pull-right">
      <button class="btn btn-default js-store-finder-pager-prev" (click)="prev()" type="button"
        [disabled]="currentPage==0">
        {{'common.storeFinder_pagination_previous'|cxTranslate}}</button>
      <button class="btn btn-default js-store-finder-pager-next" (click)="next()" type="button"
        [disabled]="currentPage+1 == $any(storeDetails).pagination.totalPages">
        {{'common.storeFinder_pagination_next'|cxTranslate}}</button>
    </div>
    <span
      class="js-store-finder-pager-item-from">{{$any(storeDetails).pagination.currentPage*$any(storeDetails).pagination.pageSize+1}}</span>-
    <span
      class="js-store-finder-pager-item-to">{{$any(storeDetails).pagination.currentPage*$any(storeDetails).pagination.pageSize+$any(storeDetails).stores.length}}</span>
    {{'common.storeDetails_table_from'|cxTranslate}}&nbsp;<span
      class="js-store-finder-pager-item-all">{{$any(storeDetails).pagination.totalResults}}</span>
    {{'common.storeFinder_pagination_stores'|cxTranslate}}
  </div>

  <div class="row map-box">
    <div class="store-list-container col-md-12 col-lg-4 col-sm-12 col-xs-12">
      <div class="store__finder--navigation mCustomScrollbar _mCS_1 scroller" #scroller1>
        <div id="mCSB_1" class="mCustomScrollBox mCS-light-thick mCSB_vertical mCSB_outside" style="max-height: none;"
          tabindex="0">
          <div id="mCSB_1_container" class="mCSB_container" dir="ltr">
            <ul class="store__finder--navigation-list js-store-finder-navigation-list"
              *ngIf="storeDetails$ | async as storeDetails">
              <li class="list__entry" *ngFor="let store of $any(storeDetails).stores; let  i= index"
                data-lat="40.745548" data-longt="-74.0061319">
                <input class="js-store-finder-input" type="radio" name="storeNamePost" id="store-filder-entry-{{i}}"
                  data-id="store-filder-entry-{{i}}" [checked]="i == 0" value="{{store.address.companyName}}">
                <label class="js-select-store-label" for="store-filder-entry-{{i}}"
                  (click)="selectStore(store.geoPoint.latitude, store.geoPoint.longitude)">
                  <span class="entry__info"><span class="entry__name">{{store.address.companyName}}</span>
                    <span class="entry__address">{{store.address.line1}}</span>
                    <span class="entry__city">{{store.address?.town}}&nbsp;
                      {{store.address?.postalCode}}</span>
                    <span class="entry__city">{{store.address?.region?.name}}</span>
                    <span class="entry__phone1">{{store.address?.phone}}</span>
                    <span class="entry__phone2"></span>
                    <span class="entry__fax"></span>
                    <span class="entry__website">
                      <a href="" target="_blank"></a>
                    </span>
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div id="mCSB_1_scrollbar_vertical"
          class="mCSB_scrollTools mCSB_1_scrollbar mCS-light-thick mCSB_scrollTools_vertical" style="display: block;">
          <div class="mCSB_draggerContainer">
            <div id="mCSB_1_dragger_vertical" class="mCSB_dragger"
              style="position: absolute; min-height: 30px; display: block; height: 231px; max-height: 690px; top: 187px;">
              <div class="mCSB_dragger_bar" style="line-height: 30px;">
              </div>
              <div class="mCSB_draggerRail"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-container col-md-12 col-lg-8 col-sm-12 col-xs-12">
      <div class="map-frame">
        <div id="map"></div>
      </div>
    </div>
  </div>
  <div class="store__finder--pagination" *ngIf="storeDetails$ | async as storeDetails">
    <div class="pull-right">
      <button class="btn btn-default js-store-finder-pager-prev" (click)="prev()" type="button"
        [disabled]="currentPage==0">
        {{'common.storeFinder_pagination_previous'|cxTranslate}}</button>
      <button class="btn btn-default js-store-finder-pager-next" (click)="next()" type="button"
        [disabled]="currentPage+1 == $any(storeDetails).pagination.totalPages">
        {{'common.storeFinder_pagination_next'|cxTranslate}}</button>
    </div>
    <span
      class="js-store-finder-pager-item-from">{{$any(storeDetails).pagination.currentPage*$any(storeDetails).pagination.pageSize+1}}</span>-
    <span
      class="js-store-finder-pager-item-to">{{$any(storeDetails).pagination.currentPage*$any(storeDetails).pagination.pageSize+$any(storeDetails).stores.length}}</span>
    {{'common.storeDetails_table_from'|cxTranslate}}&nbsp;<span
      class="js-store-finder-pager-item-all">{{$any(storeDetails).pagination.totalResults}}</span>
    {{'common.storeFinder_pagination_stores'|cxTranslate}}
  </div>
</ng-container>
<ng-container *ngIf="noRecordsFound==true">
  <div class="store-location-not-found">
    {{'common.storeFinder_noResults'|cxTranslate}}
  </div>
</ng-container>